<template>
  <v-toolbar dense flat>
    <v-btn icon @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <btn-icon-accept
        v-if="isMember"
        icon="mdi-account-box-minus-outline"
        name="Покинуть"
        text="Вы уверены что хотите покинуть чат?"
        @accept="leaveChat"
    />
    <btn-icon-accept
        v-else-if="chat"
        icon="mdi-account-box-plus-outline"
        name="Присоединиться"
        text="Вы уверены что хотите присоединиться в чат?"
        @accept="joinChat"
    />
    <v-btn v-if="chat" :loading="muteChatState.loading" icon @click="toggleMute">
      <v-icon>{{ chat.muted ? 'mdi-bell-off-outline' : 'mdi-bell-outline' }}</v-icon>
    </v-btn>
    <div class="d-flex overflow-hidden" style="min-width: 0; flex: 0 1 auto;">
      <div class="clickable hoverable fill-height px-2 rounded overflow-hidden" @click="aboutChatOpen=true">
        <div class="text-no-wrap">
          <div class="body-1 mt-1">{{ chat._name }}</div>
          <div class="body-2 mt-n1 caption">
              <span v-if="cat!==null">
                <v-icon class="mr-1" small style="margin-top:-1px">{{ cat.icon }}</v-icon>
                <span>{{ cat.name }}</span>
              </span>
            <template v-if="uniqueExternalClients.length===1">
              <template v-if="singleClientPhone">
                <dot v-if="cat!==null"/>
                <call-phone :phone="singleClientPhone" small/>
              </template>
              <template v-if="clientGender(uniqueExternalClients[0])">
                <dot v-if="cat!==null || singleClientPhone"/>
                <span>{{ clientGender(uniqueExternalClients[0]) }}</span>
              </template>
              <template v-if="clientYears(uniqueExternalClients[0])">
                <dot v-if="cat!==null || singleClientPhone || clientGender(uniqueExternalClients[0])"/>
                <span>{{ clientYears(uniqueExternalClients[0]) }}</span>
              </template>
            </template>
            <template v-else-if="uniqueExternalClients.length>1">
              <dot v-if="cat!==null"/>
              <span>несколько клиентов ({{ uniqueExternalClients.length }})</span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <dialog-page-about-chat
        :key="chat.id"
        :chat="chat"
        :open="aboutChatOpen"
        @cancel="aboutChatOpen=false"
        @saved="aboutChatOpen=false"
    />
    <div
        v-if="!small"
        class="mr-n3 overflow-x-auto"
        style="min-width: 0; flex: 1 1 0%;"
    >
      <div class="d-flex flex-nowrap justify-end" style="min-width: 100%; width: max-content;">
        <v-menu v-for="client in clients" :key="client.id" class="flex-shrink-0" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="clickable hoverable rounded fill-height px-2 text-no-wrap flex-shrink-0">
            <v-row class="rowXSmall flex-nowrap" align="center" no-gutters>
              <v-col cols="auto">
                <v-avatar size="30" color="white">
                  <img v-if="client.user && client.user.imageUrl" :src="client.user.imageUrl">
                  <v-icon v-else large>mdi-account-circle</v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="auto" class="pl-2">
                <div class="body-1 mt-1 text-no-wrap">
                  {{ client.user ? $tools.userFullName(client.user, true) : client.name }}
                </div>
                <div class="body-2 mt-n1 caption text-no-wrap">
                <span v-if="$tools.dialogProviderName(client?.provider)!==null">
                  <span>{{ $tools.dialogProviderName(client?.provider) }}</span>
                  <dot v-if="clientGender(client)"/>
                </span>
                  <span v-if="clientGender(client)">
                  <span>{{ clientGender(client) }}</span>
                </span>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <v-card width="300">
          <div class="py-2 px-4 body-2">
            <div class="body-1">{{ client.user ? $tools.userFullName(client.user) : client.name }}</div>
            <div v-if="clientGender(client)">Пол: {{ clientGender(client) }}</div>
            <div v-if="clientYears(client)">Возраст: {{ clientYears(client) }}</div>
            <div v-if="!$tools.isEmpty(client.phone)">Телефон:
              <call-phone :phone="$tools.phoneFormat(client.phone)" small/>
            </div>
            <div v-if="$tools.dialogProviderName(client.provider)">Мессенджер:
              {{ $tools.dialogProviderName(client.provider) }}
            </div>
            <tag-add v-if="client.user" :entityId="client.user.id" entityType="user" class="my-2" sideTitle/>
            <v-row class="rowXSmall">
              <v-col>
                <v-btn
                    :disabled="client.user===null" depressed small block
                    @click="$tools.openUrl('/panel/user/client/'+client.user.id+'/', true)"
                >
                  Профиль
                  <v-icon class="ml-2" dense small>mdi-open-in-new</v-icon>
                </v-btn>
              </v-col>
              <v-col>
                <v-menu max-width="300" offset-y z-index="10">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        :disabled="client._userVariants.filter(v=>v.id!==client.user?.id).length===0"
                        class="ml-2"
                        depressed
                        small block
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon class="mr-2" small>mdi-account-edit</v-icon>
                      Клиент
                      {{
                        client === null || client._userVariants.filter(v => v.id !== client.user?.id).length === 0 ? '' : '(' + client._userVariants.length + ')'
                      }}
                    </v-btn>
                  </template>
                  <v-sheet color="transparent" max-height="400" class="overflow-y-auto">
                    <v-list v-if="client!==null && client._userVariants.length>1" class="pa-0" dense>
                      <v-list-item
                          v-for="(v, i) in client._userVariants" :key="i"
                          :class="client.user?.id===v.id ? 'v-list-item--active' : ''"
                          class="pa-0"
                      >
                        <v-row no-gutters>
                          <v-col class="py-2 px-4" cols="12">
                            <div class="body-2">{{ $tools.userFullName(v, true) }}</div>
                            <div class="body-2 caption">
                              <span>{{ $tools.userGender(v) }}</span>
                              <dot/>
                              <span>{{ $tools.userYears(v) }}</span>
                              <dot/>
                              <span>{{ $tools.userTypeName(v?.type) }}</span>
                            </div>
                          </v-col>
                          <v-col class="pb-2 px-4">
                            <v-btn
                                :disabled="client.user?.id===v.id"
                                class="mr-2"
                                depressed small @click="dialogUserChangeUser(client.id, v.id)"
                            >
                              {{ client.user?.id === v.id ? 'Выбран' : 'Выбрать' }}
                            </v-btn>
                            <v-btn depressed small @click="$tools.openUrl('/panel/user/client/'+v.id+'/', true)">
                              Профиль
                              <v-icon class="ml-2" dense small>mdi-open-in-new</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col v-if="i<client._userVariants.length-1" cols="12">
                            <v-divider/>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </v-list>
                  </v-sheet>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <btn-small-accept
                    :loading="excludeUserState.loading"
                    name="Исключить"
                    icon="mdi-account-box-minus-outline"
                    text="Исключить пользователя из чата?"
                    @accept="excludeUser(client)"
                    block
                />
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-menu>
      </div>
    </div>

    <template v-slot:extension v-if="chat.cat!=='internal' && !small">
      <chip class="mt-1 clickable" @click="appealChatOpen=true">
        <v-row no-gutters class="text-left">
          <v-col cols="auto">
            <v-icon class="mr-1" style="margin-top:-2px" small>mdi-account-badge</v-icon>
          </v-col>
          <v-col>
            <div v-if="chat.callTarget==null">Не указана цель обращения</div>
            <div v-else>
              {{ chat.callTarget.name }}
              <div v-if="chat.callResult!==null" class="d-inline-block">
                <dot/>
                <v-avatar v-if="chat.callResult.type==='success'" color="success" size="12" class="mr-1"
                          style="margin-top:-2px">
                  <v-icon color="white" size="10">mdi-check</v-icon>
                </v-avatar>
                <v-avatar v-else-if="chat.callResult.type==='info'" color="blue" size="12" class="mr-1"
                          style="margin-top:-2px">
                  <v-icon color="white" size="14">mdi-information-symbol</v-icon>
                </v-avatar>
                <v-avatar v-else color="red" size="12" class="mr-1" style="margin-top:-2px">
                  <v-icon color="white" size="8">mdi-close</v-icon>
                </v-avatar>
                {{ chat.callResult.name }}
              </div>
            </div>
          </v-col>
        </v-row>
      </chip>
      <dialog-page-appeal-chat
          :chat="chat"
          :open="appealChatOpen"
          @cancel="appealChatOpen=false"
      />
    </template>
  </v-toolbar>
</template>

<script>
import Dot from "../../../../componentsV2/base/Dot.vue";
import TagAdd from "../../../Tag/components/TagAdd.vue";
import axios from "axios";
import Stater from "../../../../plugins/stater";
import DialogPageAboutChat from "./DialogPageAboutChat.vue";
import DialogPageAppealChat from "./DialogPageAppealChat.vue";
import Chip from "../../../../componentsV2/base/Chip.vue";
import BtnIconAccept from "../../../../componentsV2/base/BtnIconAccept.vue";
import BtnSmallAccept from "../../../../componentsV2/base/BtnSmallAccept.vue";
import CallPhone from "../../../../components/CallPhone.vue";

export default {
  components: {CallPhone, BtnSmallAccept, BtnIconAccept, Chip, DialogPageAppealChat, DialogPageAboutChat, TagAdd, Dot},
  props: ['cats', 'chat', 'small'],
  data: () => ({
    subscribeListenerId: null,
    leaveChatState: new Stater(),
    muteChatState: new Stater(),
    aboutChatOpen: false,
    appealChatOpen: false,
    excludeUserState: new Stater()
  }),
  computed: {
    cat() {
      if (this.chat === null) return null;

      let arr = this.cats.filter(v => v.id === this.chat.cat)
      return arr.length > 0 ? arr[0] : null;
    },
    clients() {
      if (this.chat === null) return [];
      return this.chat.dialogUsers
          .filter(v => v.provider !== 'internal');
    },
    uniqueExternalClients() {
      const map = new Map();
      for (const client of this.clients) {
        const key = client.user?.id != null ? 'u:' + client.user.id : 'd:' + client.id;
        if (!map.has(key)) {
          map.set(key, client);
          continue;
        }
        const existing = map.get(key);
        if (this.$tools.isEmpty(existing.phone) && !this.$tools.isEmpty(client.phone))
          map.set(key, client);
      }
      return [...map.values()];
    },
    singleClientPhone() {
      if (this.uniqueExternalClients.length !== 1) return null;
      const uid = this.uniqueExternalClients[0].user?.id;
      const sources = uid != null
          ? this.clients.filter(c => c.user?.id === uid)
          : this.uniqueExternalClients;
      const withPhone = sources.find(c => !this.$tools.isEmpty(c.phone));
      return withPhone ? withPhone.phone : null;
    },
    isMember() {
      const userId = this.$store.state.user?.id;
      return (this.chat?.dialogUsers || []).some(
          v => v.user?.id === userId && v.provider === 'internal'
      );
    },
  },
  watch: {
    'chat.id'() {
      this.aboutChatOpen = false;
      this.appealChatOpen = false;
    },
  },
  methods: {
    clientGender(v) {
      if (v.user) return v.user.userProfile.gender === 'male' ? 'Мужчина' : 'Женщина';
      return null;
    },
    clientYears(v) {
      if (v.user) {
        let v1 = this.$tools.dateYearsSimple(v.user.userProfile.birth, 'YYYY-MM-DD')
        return this.$tools.isEmpty(v1) ? null : v1;
      }
      return null;
    },
    dialogUserChangeUser(dialogUserId, userId) {
      axios.put('/napi/dialog/user/', {
        dialogUserId: dialogUserId,
        userId: userId,
      });
    },
    joinChat() {
      if (this.chat === null)
        return;
      axios.post('/napi/dialog/chat/' + this.chat.id + '/join/', {
        onlyMeAsInternal: true,
      });
    },
    toggleMute() {
      if (this.chat === null)
        return;
      const muted = !this.chat.muted;
      this.muteChatState.stateLoading();
      axios.put('/napi/dialog/chat/' + this.chat.id + '/config/', {
        muted,
      }).then(() => {
        this.$set(this.chat, 'muted', muted);
        this.muteChatState.stateSuccess();
      }).catch(() => {
        this.muteChatState.stateError();
      });
    },
    leaveChat() {
      this.leaveChatState.stateLoading();
      axios.post('/napi/dialog/chat/' + this.chat.id + '/leave/', {
        dialogUserId: this.chat.dialogUsers?.filter(v => v.user?.id === this.$store.state.user?.id && v.provider === 'internal')[0].id,
      }).then(() => {
        this.leaveChatState.stateSuccess();
      }).catch(() => {
        this.leaveChatState.stateError();
      });
    },
    excludeUser(dialogUser) {
      this.excludeUserState.stateLoading();
      axios.post('/napi/dialog/chat/' + this.chat.id + '/leave/', {
        dialogUserId: dialogUser.id,
      })
          .then(() => {
            this.excludeUserState.stateSuccess();
          }).catch(() => {
        this.excludeUserState.stateError();
      });
    },
  }
}
</script>